<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['monitor:elasticResourceAli:log']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.operationLog") }}</Button
        >
        <Button
          type="warning"
          size="small"
          v-hasPermission="['monitor:elasticResourceAli:edit_alert_rule']"
          @click="addOrUpdateHandle(row.id)"
          >{{ $t("alarms.common.edit") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['monitor:elasticResourceAli:delete_alert_rule']"
            @click="EipWarningModal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除模式框 -->
    <Modal v-model="EipWarningModal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alertRuleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeSlbWarning()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-elastic-resource-ali-warning
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-elastic-resource-ali-warning>
  </div>
</template>
<script>
import AlertRuleOperationLog from "../common/AlertRuleOperationLog";
import { setCookie, getCookie } from "../../../utils/cookieUtil";
import TableElasticResourceAli from "../eip/TableElasticResourceAli";
import AddOrUpdateElasticResourceAliWarning from "../eip/AddOrUpdateElasticResourceAliWarning";
var tableElasticResourceAli = TableElasticResourceAli;
var tableElasticResourceAliWarningVue = {};
export default {
  name: "TableElasticResourceAliWarning",
  components: {
    AddOrUpdateElasticResourceAliWarning,
    AlertRuleOperationLog
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      addOrUpdateVisible: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      EipWarningModal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      alertRuleName: "",
      columns: [
        {
          title: this.$t("alarms.common.alertRuleName"),
          key: "alertRuleName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 0 enabled,1 disabled
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == 0 // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("alarms.common.enable")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("alarms.common.disable")
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName"
        },
        {
          title: this.$t("alarms.common.alertRule"),
          key: "alertRuleDesc"
        },
        {
          title: this.$t("alarms.common.contact"),
          key: "contactNameList"
        },
        {
          title: this.$t("alarms.common.delayType"),
          key: "delayName"
        },
        {
          title: this.$t("alarms.common.delayCountdown"),
          key: "alarmDelayCountdown"
        },
        {
          title: this.$t("alarms.common.scanType"),
          key: "scanTypeName"
        },
        {
          title: this.$t("common.operation"),
          width: 200,
          slot: "delete"
        }
      ],
      tableDate: []
    };
  },
  beforeCreate: function() {
    tableElasticResourceAliWarningVue = this;
  },
  mounted: function() {
    tableElasticResourceAliWarningVue.getEipWarningData();
  },
  methods: {
    showAll: function() {
      tableElasticResourceAliWarningVue.getEipWarningData();
    },
    // 分页显示数据
    /****************************************************/
    getEipWarningData: function() {
      // 获取SlbWarningSearch里面的搜索内容
      eventBus.$on("alertRuleSearchName", function(val) {
        tableElasticResourceAliWarningVue.alertRuleSearchName = val;
      });
      eventBus.$on("companyId", function(val) {
        tableElasticResourceAliWarningVue.companyId = val;
      });
      eventBus.$on("accountId", function(val) {
        tableElasticResourceAliWarningVue.accountId = val;
      });
      eventBus.$on("stateId", function(val) {
        tableElasticResourceAliWarningVue.stateId = val;
      });
      eventBus.$on("typeId", function(val) {
        tableElasticResourceAliWarningVue.typeId = val;
      });
      eventBus.$on("delayTypeId", function(val) {
        tableElasticResourceAliWarningVue.delayTypeId = val;
      });
      eventBus.$on("instanceId", function(val) {
        tableElasticResourceAliWarningVue.instanceId = val;
      });
      eventBus.$on("monitorIndex", function(val) {
        tableElasticResourceAliWarningVue.monitorIndex = val;
      });
      //列表分页
      const alertRuleDate = {
        loadbalancerName: this.$route.query.name,
        alertRuleName: tableElasticResourceAliWarningVue.alertRuleSearchName,
        companyId: tableElasticResourceAliWarningVue.companyId,
        accountId: tableElasticResourceAliWarningVue.accountId,
        stateId: tableElasticResourceAliWarningVue.stateId,
        typeId: tableElasticResourceAliWarningVue.typeId,
        delayTypeId: tableElasticResourceAliWarningVue.delayTypeId,
        instanceId:
          this.$route.query.instanceId == null
            ? tableElasticResourceAliWarningVue.instanceId
            : this.$route.query.instanceId,
        pageNum: this.current,
        pageSize: this.pageSize,
        monitorModule: 37
      };
      if (this.$route.query.loadbalancerType == "CLB") {
        alertRuleDate.monitorModule = 6;
      } else if (this.$route.query.loadbalancerType == "ELB") {
        alertRuleDate.monitorModule = 27;
      }
      this.$api.alertRule.pageAlertRule(alertRuleDate).then(res => {
        this.tableDate = res.data.records;
        // 当前页
        this.current = res.data.current;
        // 总条数
        this.dataTotal = res.data.total;
      });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticResourceAliWarningVue.getEipWarningData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticResourceAliWarningVue.getEipWarningData();
    },
    // 销毁alertRuleSearchName
    beforeDestroy: function() {
      eventBus.$off("alertRuleSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0启用 1禁用
      if (this.tableDate[index].state == 0) {
        this.changeStatusMessage(this.tableDate[index].id, "state", 1);
      } else {
        this.changeStatusMessage(this.tableDate[index].id, "state", 0);
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.alertRule
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableElasticResourceAliWarningVue.getEipWarningData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alertRuleName = this.tableDate[index].alertRuleName;
    },
    removeSlbWarning: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.alertRule
        .deleteAlertRule("id", this.tableDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableElasticResourceAliWarningVue.getEipWarningData();
            tableElasticResourceAli.methods.showAll();
            this.isDisable = false;
            this.modal_loading = false;
            this.EipWarningModal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 编辑报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
      });
    }
  }
};
</script>
<style scoped>
.instanceAli-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/eip/TableElasticResourceAliWarning.vue